import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { setTheme, AppTheme } from '../store/slices/themeSlice';

export const useTheme = () => {
  const dispatch = useDispatch();
  const theme = useSelector((state: RootState) => state.theme.theme);

  const changeTheme = (newTheme: AppTheme) => {
    dispatch(setTheme(newTheme));
  };

  // Helper to check if theme is dark
  const isDark = theme === 'alpine-dark' || theme === 'quartz-dark';
  const isLight = theme === 'alpine' || theme === 'quartz';

  return {
    theme,
    changeTheme,
    isDark,
    isLight,
  };
};

